import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useLayoutEffect,
} from "react";
import api from "../../api";
import { Card } from "antd";
import MonthlySalary from "./monthlySalary";
import Footer from "../../Footer";
import CommonSelect from "../../core/common/commonSelect";
import { encryptQuery, decryptQuery } from "../../utils/encryption";
import { toast, ToastContainer } from "react-toastify";
import {
  HeaderFilterProvider,
  useHeaderFilters,
} from "../../context/HeaderFilterContext";
import { useNavigate, useLocation } from "react-router-dom";
import Table from "../../core/common/dataTable/index";
import StatCardGrid from "./statCardGrid";
import useDynamicPageSize from "../../useDynamicPageSize";
import { useIsMobile } from "../../hooks/useIsMobile";

type Option = { label: string; value: any };

interface EmployeeSalaryData {
  employee_id: number;
  name: string;
  designation_title: string;
  image_url: string;
  total_gross: number;
  total_incentives: number;
  total_security_deposit: number;
  total_tds: number;
  total_pt: number;
  total_pf: number;
  total_esic: number;
  total_net_salary: number;
  any_flag: boolean;
}

interface SalaryData {
  id: string;
  month: string;
  gross: number;
  incentives: number;
  securityDeposit: number;
  tds: number;
  pt: number;
  pf: number;
  esic: number;
  totalAmount: number;
  successBadge?: string;
  atLeastOneDisbursed?: boolean;
  bulkDownloadOptions?: any;
  fiscalMonth: number;
  year: number;
   employeeId?: number;         //  new
  employeeName?: string; 
}

interface SalaryDetails {
  employeeSalaries: EmployeeSalaryData[];
  selectedYear: string;
  pagination: {
    current_page: number;
    last_page: number;
    total: number;
  };
  totalsd: string;
  totaltds: string;
  totalnet: string;
  totalgross: string;
  totalpf: string;
  totalesic: string;
}

function getFinancialYear(year: number): string {
  return `FY: ${String(year).slice(-2)}-${String(year + 1).slice(-2)}`;
}

function getCurrentFinancialYear(): string {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  return month >= 3 ? getFinancialYear(year) : getFinancialYear(year - 1);
}

const Payroll: React.FC = () => {
  const isMobile = useIsMobile(991);

  const { setFilters } = useHeaderFilters();
  const navigate = useNavigate();
  const location = useLocation();
  const isInitialFetch = useRef(true);
  const [tableHeight, setTableHeight] = useState<number>(0);
  const [totalItems, setTotalItems] = useState(0);
  const [isSending, setIsSending] = useState(false);
   const queryParams = new URLSearchParams(location.search);
    const [errorMessage, setErrorMessage] = useState("");
    
 useLayoutEffect(() => {
  const calcHeight = () => {
    const w = window.innerWidth;
    const h = window.innerHeight;

    const isTablet = w > 575 && w <= 991;
    const isMobile = w <= 575 || w <= 991;

    let topBlocks = 0;
    if (w <= 360)        topBlocks = 210;   
    else if (w <= 410)   topBlocks = 210;   
    else if (w <= 575)   topBlocks = 210;  
    else if (w <= 767)   topBlocks = 130;   
    else if (w <= 991)   topBlocks = 130;   
    else                 topBlocks = 110;   

    const pagination = document.getElementById("pagination-bar");
    const footer     = document.getElementById("footer");
    const paginationH = pagination?.offsetHeight ?? 56;
    const footerH     = footer?.offsetHeight ?? 50;

    const reserved = topBlocks + paginationH + footerH;
    const newHeight = Math.max(220, h - reserved);

    setTableHeight(newHeight);
  };

  calcHeight();                      // initial
  window.addEventListener("resize", calcHeight);
  return () => window.removeEventListener("resize", calcHeight);
}, []);

  const user = JSON.parse(localStorage.getItem("user") || "{}");

  // Dropdown options
  const yearOptions: Option[] = [...Array(5)].map((_, i) => {
    const y = new Date().getFullYear() - i;
    const fy = getFinancialYear(y);
    return { label: fy, value: fy };
  });
  const groupByOptions: Option[] = [
    { label: "Monthly View", value: "monthly" },
    { label: "Employee View", value: "employee" },
  ];

  // State
  const defaultYear = getCurrentFinancialYear();
  const defaultGroupBy: "monthly" = "monthly";
  const [selectedGroupBy, setSelectedGroupBy] = useState<
    "monthly" | "employee"
  >(defaultGroupBy);
  const [selectedYear, setSelectedYear] = useState(defaultYear);
  const [salaryData, setSalaryData] = useState<SalaryData[]>([]);
  const [employeeSalaries, setEmployeeSalaries] = useState<
    EmployeeSalaryData[]
  >([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = useDynamicPageSize();
  const safePageSize =
    pageSize > 0 ? pageSize : totalItems > 0 ? totalItems : 1;
  const [showMailModal, setShowMailModal] = useState(false);
  const openMailConfirm = () => setShowMailModal(true);
  const closeMailConfirm = () => setShowMailModal(false);
  const [loading, setLoading] = useState(true);
  const [modalMonth, setModalMonth] = useState<number | null>(null);
  const [modalYear, setModalYear] = useState<number | null>(null);
  const [modalMonth2, setModalMonth2] = useState<number | null>(null);
  const [modalYear2, setModalYear2] = useState<number | null>(null);
  const [totalGross, setTotalGross] = useState("0");
  const [totalSD, setTotalSD] = useState("0");
  const [totalTDS, setTotalTDS] = useState("0");
  const [totalNet, setTotalNet] = useState("0");
  const [totalPf, setTotalPf] = useState("0");
  const [totalEsic, setTotalEsic] = useState("0");
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 991);

  const isMonthly = selectedGroupBy === "monthly";

  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));
  const filterPanelRef = useRef<HTMLDivElement>(null);

  const formatCurrency = (value: number | string) =>
    new Intl.NumberFormat("en-IN", {
      // style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    }).format(Number(value));

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 991);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const resetFilters = () => {
    const defaultYear = getCurrentFinancialYear();
    setSelectedYear(defaultYear);
    setSelectedGroupBy("monthly");
    setCurrentPage(1);
    updatePayrollUrl(defaultYear, "monthly", 1);  

    // Reset URL
    navigate("/payroll", { replace: true });
  };

  // Effects
  //   useEffect(() => {
  //     setPageSize(Math.floor((window.innerHeight - 300) / 40));
  //     const onResize = () => setIsMobileView(window.innerWidth <= 767);
  //     window.addEventListener("resize", onResize);
  //     return () => window.removeEventListener("resize", onResize);
  //   }, []);

  // 1. Read encrypted filters from URL once on mount
  useEffect(() => {
    const [, , encoded] = location.pathname.split("/");

    if (encoded) {
      try {
        const { selectedYear: y, selectedGroupBy: g , page: p} = decryptQuery(
          decodeURIComponent(encoded)
        ) as {
       selectedYear?: string;
       selectedGroupBy?: "monthly" | "employee";
       page?: number;
     };

        setSelectedYear(y ?? getCurrentFinancialYear());
        setSelectedGroupBy(g ?? "monthly");
        setCurrentPage(g === "employee" ? Number(p) || 1 : 1);
      } catch (e) {
        console.warn("Failed to decrypt payroll query:", e);
        setSelectedYear(getCurrentFinancialYear());
        setSelectedGroupBy("monthly");
        setCurrentPage(1);
      }
    } else {
      // no encoded segment → back to defaults
      setSelectedYear(getCurrentFinancialYear());
      setSelectedGroupBy("monthly");
      setCurrentPage(1);
    }
  }, [location.pathname]);

  function updatePayrollUrl(year: string, groupBy: "monthly" | "employee",page = 1) {
    // if both are default, go back to clean /payroll
    const payload: any = { selectedYear: year, selectedGroupBy: groupBy };
  // only store page for Employee view (keeps URLs short)
  if (groupBy === "employee" && page > 1) payload.page = page;

  const defaults =
    year === getCurrentFinancialYear() && groupBy === "monthly" && page === 1;

  if (defaults) {
    navigate("/payroll", { replace: false });
  } else {
    const enc = encodeURIComponent(encryptQuery(payload));
    navigate(`/payroll/${enc}`, { replace: false });
  }
  }

  // 2. Fetch data when filters change
  useEffect(() => {
    if (isInitialFetch.current) {
      isInitialFetch.current = false;
      return;
    }
    fetchData();
  }, [selectedYear, selectedGroupBy, currentPage, pageSize]);

  // 3. Update encrypted URL when filters change (but skip initial mount)
  //   const didMountRef = useRef(false);

  //  useEffect(() => {
  //     if (!didMountRef.current) {
  //       didMountRef.current = true;
  //       return;
  //     }

  //     const filtersAreDefault =
  //       selectedYear === getCurrentFinancialYear() &&
  //       selectedGroupBy === "monthly";

  //     if (filtersAreDefault) {
  //       navigate("/payroll", { replace: true });
  //     } else {
  //       const encrypted = encryptQuery({ selectedYear, selectedGroupBy });
  //       const encoded = encodeURIComponent(encrypted);
  //       navigate(`/payroll/${encoded}`, { replace: true });
  //     }
  //   }, [encryptQuery,selectedYear, selectedGroupBy]);

  // Data fetching
  const fetchData = async () => {
    setLoading(true);
    await sleep(0); // artificial delay
    if (isMonthly) {
      await loadSalaryDetails();
    } else {
      await loadEmployeeSalary();
    }
  };

  const loadEmployeeSalary = async () => {
    try {
      const res = await api<SalaryDetails>("/group-by-employee", {
        method: "POST",
        body: { year: selectedYear, currentPage, pageSize: pageSize },
      });
      if (Array.isArray(res.employeeSalaries)) {
        setEmployeeSalaries(res.employeeSalaries);
        setCurrentPage(res.pagination.current_page);
        setTotalGross(res.totalgross);
        setTotalSD(res.totalsd);
        setTotalTDS(res.totaltds);
        setTotalPf(res.totalpf);
        setTotalEsic(res.totalesic);
        setTotalNet(res.totalnet);
        setTotalItems(res.pagination.total || 0);
      } else {
        toast.error("Invalid data from server");
      }
    } catch {
      toast.error("Failed to load employee salary");
    } finally {
      setLoading(false);
    }
  };

  const handleSendConfirm = () => {
    // put your “send mail” logic here, e.g.
    // await api.post('/send-mail', { month: modalMonth, year: modalYear });
    toast.success("Mail sent!");
    closeMailConfirm();
  };

  const loadSalaryDetails = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const endpoint =
        user.role_name === 1
          ? `/home-page-salary/${user.id}`
          : `/employee-salary`;

      const res = await api<any>(endpoint, {
        method: "POST",
        body: { currentPage, pageSize, year: selectedYear },
      });

      const {
        totals,
        disbursedStatus,
        atLeastOneDisbursed,
        bulkDownloadOptions,
        totalgross,
        totalsd,
        totaltds,
        totalnet,
        totalesic,
        totalpf,
      } = res;

      setSalaryData(
        formatData(
          selectedYear,
          totals,
          disbursedStatus,
          atLeastOneDisbursed,
          bulkDownloadOptions,
          user,
        )
      );

      setTotalGross(totalgross?.toString() || "0");
      setTotalSD(totalsd?.toString() || "0");
      setTotalTDS(totaltds?.toString() || "0");
      setTotalNet(totalnet?.toString() || "0");
      setTotalPf(totalpf?.toString() || "0");
      setTotalEsic(totalesic?.toString() || "0");
    } catch {
      toast.error("Failed to load salary details");
    } finally {
      setLoading(false);
    }
  };

  // Formatter
  function formatData(
    selectedYear: string,
    totals: Record<number, Record<number, any>>,
    disbursedStatus: Record<number, Record<number, string>>,
    atLeastOneDisbursed: Record<number, boolean>,
    bulkDownloadOptions: Record<number, any>,
     user: {
       name: string | undefined;
       id: number | undefined; role_name: number 
}
  ): SalaryData[] {
    const months = [
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
      "Jan",
      "Feb",
      "Mar",
    ];

    const yearStart = 2000 + parseInt(selectedYear.substring(4, 6), 10);
    const nextYear = yearStart + 1;

    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;
   const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;

    const data: SalaryData[] = [];

    for (let i = 0; i < 12; i++) {
      const fiscalMonth = ((i + 3) % 12) + 1;
      const displayYear = fiscalMonth >= 4 ? yearStart : nextYear;

      const raw = totals?.[displayYear]?.[fiscalMonth];
      const isPreviousMonth =
        fiscalMonth === previousMonth &&
        (
          (previousMonth === 12 && displayYear === currentYear - 1) ||
          (previousMonth !== 12 && displayYear === currentYear)
        );

const isCurrentMonth =
  fiscalMonth === currentMonth && displayYear === currentYear;

        
         // If role_name is 1, only allow current month
    if (user.role_name === 2 && !raw) {
      continue;
    }
        
      if (!raw && !isCurrentMonth && !isPreviousMonth) {
        continue; // skip months with no data unless it's the current month
      }

      data.push({
        id: `${fiscalMonth}-${displayYear}`,
        month: `${months[i]}-${String(displayYear).slice(-2)}`,
        gross: raw?.Gross || 0,
        incentives: raw?.incentives || 0,
        securityDeposit: raw?.Security_deposit || 0,
        tds: raw?.TDS || 0,
        pt: raw?.PT || 0,
        pf: raw?.PF || 0,
        esic: raw?.ESIC || 0,
        totalAmount: raw?.Net_salary || 0,
        successBadge: disbursedStatus?.[displayYear]?.[fiscalMonth] || "",
        atLeastOneDisbursed: atLeastOneDisbursed[fiscalMonth] ?? false,
        bulkDownloadOptions: bulkDownloadOptions[fiscalMonth] ?? null,
        fiscalMonth,
        year: displayYear,
        employeeId: user.id,           //  add this
        employeeName: user.name 
      });
    }

    return data;
  }

  // downloads a Blob via your api wrapper
  const handleDownloadPayslips = async (month: number, year: number) => {
    try {
      const blob = await api<Blob>("/download-all-payslip", {
        method: "POST",
        body: { month, year },
        responseType: "blob", // ← request a blob
      });

      const url = URL.createObjectURL(blob);
      const date = new Date(year, month - 1);
      const label = date.toLocaleString("default", {
        month: "short",
        year: "2-digit",
      });
      const a = document.createElement("a");
      a.href = url;
      a.download = `Payslips_${label}.zip`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      toast.error("Failed to download payslips");
    }
  };

const handlePrintClick = async (rec: SalaryData) => {
  try {
    const userId = rec.employeeId;
    const userName = rec.employeeName;

    if (!userId || !userName) {
      toast.error("Missing employee information for download.");
      return;
    }

    const fiscalMonth = rec.fiscalMonth;
    const year = rec.year;

    const response = await api<Blob>(
      `/create-pdf-file/${userId}/${year}/${fiscalMonth}`,
      {
        method: "GET",
        responseType: "blob",
        headers: {
          Accept: "application/pdf",
        },
      }
    );

    const filename = `${userId}-${userName}-${fiscalMonth}-${year}-Slip.pdf`;

    const blob = new Blob([response], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  } catch (error) {
    console.error("Error while generating PDF:", error);
    setErrorMessage("The requested payslips are not available.");
    setTimeout(() => setErrorMessage(""), 3000);
  }
};



  // Column definitions
  const getMonthlyColumns = (
    onSend: (m: number, y: number) => void,
    onZip: (m: number, y: number) => void,
    onExcel: (m: number, y: number) => void,
    onBank: (m: number, y: number) => void
  ) =>
    user.role_name === 1
      ? [
          {
            title: "Months",
            dataIndex: "month",
            key: "month",
            align: "center",
            render: (
              text:
                | string
                | number
                | boolean
                | React.ReactElement<
                    any,
                    string | React.JSXElementConstructor<any>
                  >
                | Iterable<React.ReactNode>
                | React.ReactPortal
                | null
                | undefined
            ) => (
              <div
                style={{
                  height: "36.5px",
                  lineHeight: "36.5px",
                  overflow: "hidden",
                  cursor: "pointer",
                }}
              >
                {text}
              </div>
            ),
          },
          {
            title: "Gross[₹]",
            dataIndex: "gross",
            key: "gross",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
          {
            title: "Inct[₹]",
            dataIndex: "incentives",
            key: "incentives",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
          {
            title: "SD[₹]",
            dataIndex: "securityDeposit",
            key: "securityDeposit",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
          {
            title: "TDS[₹]",
            dataIndex: "tds",
            key: "tds",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
          {
            title: "PT[₹]",
            dataIndex: "pt",
            key: "pt",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
           {
            title: "PF[₹]",
            dataIndex: "pf",
            key: "pf",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
           {
            title: "ESIC[₹]",
            dataIndex: "esic",
            key: "esic",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
          {
            title: "Net[₹]",
            dataIndex: "totalAmount",
            key: "totalAmount",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
          {
            title: "Status",
            dataIndex: "successBadge",
            key: "status",
            align: "center",
            render: (txt: string) =>
              txt && <span className="badge bg-success text-white">{txt}</span>,
          },
          {
            title: "Action",
            key: "action",
            align: "center",
            render: (_: any, rec: SalaryData) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "0.5rem",
                }}
              >
                {/* ————— Mail slot ————— */}
                <span style={{ width: 32, textAlign: "center" }}>
                  {rec.atLeastOneDisbursed ? (
                    <button
                      className="btn btn-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        setModalMonth(rec.fiscalMonth);
                        setModalYear(rec.year);
                        openMailConfirm();
                      }}
                      title="Send Mail"
                    >
                      <i className="fa fa-envelope" />
                    </button>
                  ) : (
                    // inert placeholder:
                    <span style={{ width: 32, display: "inline-block" }} />
                  )}
                </span>

                {/* ————— ZIP Download slot ————— */}
                <span style={{ width: 32, textAlign: "center" }}>
                  {rec.atLeastOneDisbursed ? (
                    <button
                      className="btn btn-icon"
                      title="Download Zip"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDownloadPayslips(rec.fiscalMonth, rec.year);
                      }}
                    >
                      <i className="fa fa-download" />
                    </button>
                  ) : (
                    <span style={{ width: 32, display: "inline-block" }} />
                  )}
                </span>

                {/* ————— Excel Download slot ————— */}
                <span style={{ width: 32, textAlign: "center" }}>
                  {rec.bulkDownloadOptions ? (
                    <button
                      className="btn btn-icon"
                      title="Download Excel"
                      onClick={(e) => {
                        e.stopPropagation();
                        downloadExcelMonthly(rec.fiscalMonth, rec.year);
                      }}
                    >
                      <i className="fas fa-file-excel" />
                    </button>
                  ) : (
                    <span style={{ width: 32, display: "inline-block" }} />
                  )}
                </span>

                {/* ————— Bank Upload slot ————— */}
                <span style={{ width: 32, textAlign: "center" }}>
                  {rec.bulkDownloadOptions ? (
                    <button
                      className="btn btn-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        bulkUploadExcel(rec.fiscalMonth, rec.year);
                      }}
                      title="Bank Upload"
                    >
                      <i className="fa fa-university" />
                    </button>
                  ) : (
                    <span style={{ width: 32, display: "inline-block" }} />
                  )}
                </span>
              </div>
            ),
          },
        ]
      : [
          {
            title: "Months",
            dataIndex: "month",
            key: "month",
            align: "center",
            render: (
              text:
                | string
                | number
                | boolean
                | React.ReactElement<
                    any,
                    string | React.JSXElementConstructor<any>
                  >
                | Iterable<React.ReactNode>
                | React.ReactPortal
                | null
                | undefined
            ) => (
              <div
                style={{
                  height: "36.5px",
                  lineHeight: "36.5px",
                  overflow: "hidden",
                  cursor: "pointer",
                }}
              >
                {text}
              </div>
            ),
          },
          {
            title: "Gross[₹]",
            dataIndex: "gross",
            key: "gross",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
          {
            title: "Inct[₹]",
            dataIndex: "incentives",
            key: "incentives",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
          {
            title: "SD[₹]",
            dataIndex: "securityDeposit",
            key: "securityDeposit",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
          {
            title: "TDS[₹]",
            dataIndex: "tds",
            key: "tds",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
          {
            title: "PT[₹]",
            dataIndex: "pt",
            key: "pt",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
          {
            title: "PF[₹]",
            dataIndex: "pf",
            key: "pf",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
           {
            title: "ESIC[₹]",
            dataIndex: "esic",
            key: "esic",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },
          {
            title: "Net[₹]",
            dataIndex: "totalAmount",
            key: "totalAmount",
            align: "right",
            render: (v?: number) =>
              v != null ? v.toLocaleString("en-IN") : "–",
          },

          {
            title: "Action",
            key: "action",
            align: "center",
            render: (_: any, rec: SalaryData) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "0.5rem",
                }}
              >
                {/* ————— Mail slot ————— */}
                <span style={{ width: 32, textAlign: "center" }}>
                  {rec.atLeastOneDisbursed ? (
                    <button
                      className="btn btn-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        setModalMonth2(rec.fiscalMonth);
                        setModalYear2(rec.year);
                        openMailConfirm();
                      }}
                      title="Send Mail"
                    >
                      <i className="fa fa-envelope text-info" />
                    </button>
                  ) : (
                    // inert placeholder:
                    <span style={{ width: 32, display: "inline-block" }} />
                  )}
                </span>

                {/* ————— ZIP Download slot ————— */}
                <span style={{ width: 32, textAlign: "center" }}>
                  {rec.atLeastOneDisbursed ? (
                    <button
                      className="btn btn-icon"
                      title="Download Zip"
                      onClick={(e) => {
                        e.stopPropagation();
                       handlePrintClick(rec);
                      }}
                    >
                      <i className="fa fa-download" />
                    </button>
                  ) : (
                    <span style={{ width: 32, display: "inline-block" }} />
                  )}
                </span>
              </div>
            ),
          },
        ];

  const getYearlyColumns = (
    page: number,
    ps: number,
    onRowClick: (id: number, name: string) => void,
    onZip: (id: number) => void,
    onExcel: (id: number) => void
  ) => [
   {
  title: "Name",
  dataIndex: "name",
  key: "name",
  render: (_: any, rec: EmployeeSalaryData) => {
    const maxNameLength = 15;
    const maxDesignationLength = 20;

    const truncateText = (text: string, maxLength: number) =>
      text && text.length > maxLength
        ? text.substring(0, maxLength) + "..."
        : text;

    return (
      <div
        className="d-flex align-items-center"
        style={{ cursor: "pointer" }}
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          e.stopPropagation();
          handleImageClick(rec.employee_id, rec.name);
        }}
      >
        <img
          src={
            rec.image_url ||
            "assets/img/users/default.jpg"
          }
          alt={rec.name}
          className="rounded-circle"
          style={{
            width: 32,
            height: 32,
            objectFit: "cover",
            marginRight: "10px",
          }}
        />
        <div>
          <h6
            className="mb-0"
            title={rec.name}
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              maxWidth: 160,
            }}
          >
            {truncateText(rec.name, maxNameLength)}
          </h6>
          <span
            className="text-muted"
            title={rec.designation_title}
            style={{
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              maxWidth: 160,
              display: "inline-block",
            }}
          >
            {truncateText(rec.designation_title, maxDesignationLength)}
          </span>
        </div>
      </div>
    );
  },
},
    {
      title: "Gross[₹]",
      dataIndex: "total_gross",
      key: "gross",
      align: "right",
      render: (v?: number) => (v != null ? v.toLocaleString("en-	IN") : "–"),
    },
    {
      title: "Inct[₹]",
      dataIndex: "total_incentives",
      key: "incentives",
      align: "right",
      render: (v?: number) => (v != null ? v.toLocaleString("en-	IN") : "–"),
    },
    {
      title: "SD[₹]",
      dataIndex: "total_security_deposit",
      key: "sd",
      align: "right",
      render: (v?: number) => (v != null ? v.toLocaleString("en-	IN") : "–"),
    },
    {
      title: "TDS[₹]",
      dataIndex: "total_tds",
      key: "tds",
      align: "right",
      render: (v?: number) => (v != null ? v.toLocaleString("en-	IN") : "–"),
    },
    {
      title: "PT[₹]",
      dataIndex: "total_pt",
      key: "pt",
      align: "right",
      render: (v?: number) => (v != null ? v.toLocaleString("en-	IN") : "–"),
    },
    {
      title: "PF[₹]",
      dataIndex: "total_pf",
      key: "pf",
      align: "right",
      render: (v?: number) =>
      v != null ? v.toLocaleString("en-IN") : "–",
    },    
    {
      title: "ESIC[₹]",
      dataIndex: "total_esic",
      key: "esic",
      align: "right",
      render: (v?: number) =>
      v != null ? v.toLocaleString("en-IN") : "–",
    },
    {
      title: "Net[₹]",
      dataIndex: "total_net_salary",
      key: "net",
      align: "right",
      render: (v?: number) => (v != null ? v.toLocaleString("en-	IN") : "–"),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_: any, rec: EmployeeSalaryData) =>
        rec.any_flag ? (
          <>
            <button
              className="btn btn-icon"
              title="Download ZIP"
              onClick={(e) => {
                e.stopPropagation();
                handleDownloadZipYearly(rec.employee_id);
              }}
            >
              <i className="fa fa-download" />
            </button>
            <button
              className="btn btn-icon"
              onClick={(e) => {
                e.stopPropagation();
                handleEmployeeExcel(rec.employee_id, rec.name);
              }}
              title="Download Excel"
            >
              <i className="fa fa-file-excel" />
            </button>
          </>
        ) : (
          <span className="empty-download-space" />
        ),
    },
  ];

  // Handlers
  const handleSendInvoice = (m: number, y: number) => {
    /* … */
  };
  const handleDownloadZip = (m: number, y: number) => {
    /* … */
  };
  const handleDownloadExcel = async (year: string, groupBy: string) => {
    try {
      const response = await api<Blob>("/download-excel/" + year, {
        method: "POST",
        body: { groupBy },
        responseType: "blob",
        // important if your `api` wraps/fetches directly and doesn't auto-convert blob
      });

      // Extract filename from content-disposition header
      const contentDisposition =
        (response as any)?.headers?.get?.("content-disposition") || "";
      const filenameRegex = /filename=["']?([^"']+)["']?/;
      const matches = contentDisposition.match(filenameRegex);

      const filename =
        matches && matches[1] ? matches[1] : `Monthly_Salaries_${year}.xlsx`;

      const url = URL.createObjectURL(response as Blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error while generating Excel:", error);
      toast.error("Failed to download Excel file");
    }
  };

  const downloadExcelMonthly = async (month: number, year: number) => {
    try {
      const blob = await api<Blob>("/download-monthly-excel", {
        method: "POST",
        body: { month, year },
        responseType: "blob",
      });

      // Optional: you can parse filename from headers if api() provides headers, otherwise use a default
      const date = new Date(year, month - 1);
      const label = date.toLocaleString("default", {
        month: "short",
        year: "2-digit",
      });

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `SalarySlip_${label}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error downloading monthly Excel:", err);
      toast.error("Failed to download salary slip Excel");
    }
  };

  const bulkUploadExcel = async (month: number, year: number) => {
    try {
      const blob = await api<Blob>("/bulk-upload-excel", {
        method: "POST",
        body: { month, year },
        responseType: "blob",
      });

      // build a nice filename, e.g. "BulkUpload_Apr-24.xlsx"
      const date = new Date(year, month - 1);
      const label = date.toLocaleString("default", {
        month: "short",
        year: "2-digit",
      });

      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `BulkUpload_${label}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Bulk upload download error:", err);
      toast.error("Failed to download bulk upload Excel");
    }
  };
  const handleBankUpload = (m: number, y: number) => {
    /* … */
  };
  const handleMonthlySalary = (m: number, y: number) => {
    const monthName = new Date(y, m - 1).toLocaleString("default", {
      month: "short",
    });
    const monthYear = `${monthName}-${String(y).slice(-2)}`;
    const payrollUrl = `/monthlySalary?month=${m}&year=${y}`;

    sessionStorage.setItem("payrollLastUrl", payrollUrl);
    sessionStorage.setItem("monthYear", monthYear); // <-- add this
    sessionStorage.setItem("month", m.toString());  // NEW
    sessionStorage.setItem("year", y.toString());   // NEW
    
    navigate(payrollUrl, {
      state: { monthYear, month:m,year:y,previousUrl: location.pathname + location.search },
    });
  };

  const handleEmployeeSalary = (employeeId: number, employeeName: string) => {
    // remove any stale month‐crumb
    sessionStorage.removeItem("monthYear");
    const queryParams = new URLSearchParams(location.search);
    const year = selectedYear;
    const payrollUrl = `/employeeSalary?employeeId=${employeeId}&year=${year}`;

    sessionStorage.setItem("payrollLastUrl", payrollUrl);
    sessionStorage.setItem("employeeName", employeeName); // <-- add this

    navigate(payrollUrl, {
      state: { employeeName, previousUrl: location.pathname + location.search },
    });

    // const previousUrl = location.pathname + location.search;
    // navigate(`/profile/${employeeId}`, {
    //   state: {
    //     from: "payroll",
    //     payrollUrl: previousUrl,
    //     employeeName,
    //     // <-- no monthYear here
    //   },
    // });
  };

  const handleEmployeeExcel = async (
    employeeId: number,
    employeeName: string
  ) => {
    try {
      const year = selectedYear;

      const response = await api<Blob>(
        `/download-employee-excel/${employeeId}/${year}`,
        {
          method: "GET",
          responseType: "blob",
        }
      );

      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Sanitize employee name to remove unsafe characters
      const safeName = employeeName.replace(/[^a-zA-Z0-9-_]/g, "_");
      const safeYear = year.replace(/[:\/\\]/g, "-");
      const filename = `${safeName}_${safeYear}.xlsx`;

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    } catch (error) {
      console.error("Error while downloading employee Excel:", error);
    }
  };

  const handleDownloadZipYearly = async (employeeId: number) => {
    try {
      // encode your selected FY so spaces/colons become “%20” etc.
      const fyParam = encodeURI(selectedYear);
      // call your api wrapper, asking for a blob back
      const blob = await api<Blob>(`/downloadzip/${employeeId}/${fyParam}`, {
        method: "GET",
        responseType: "blob",
      });

      // then trigger a browser download
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Employee_${employeeId}_${selectedYear}.zip`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      toast.error("Failed to download ZIP");
    }
  };

  const handleDownloadExcelYearly = (id: number) => {
    /* … */
  };

  // Swapable props
  const dataSource = isMonthly ? salaryData : employeeSalaries;
  const columns = isMonthly
    ? getMonthlyColumns(
        handleSendInvoice,
        handleDownloadZip,
        bulkUploadExcel,
        handleBankUpload
      )
    : getYearlyColumns(
        currentPage,
        pageSize,
        handleEmployeeSalary,
        handleDownloadZipYearly,
        handleDownloadExcelYearly
      );
  const rowKey = isMonthly ? "id" : "employee_id";
  const totalItemsCount = selectedGroupBy === "employee" ? totalItems : 0;
  const handlePageChange =
  selectedGroupBy === "employee"
    ? (page: number, ps?: number) => {
        setCurrentPage(page); //  Only update page
        //  DO NOT call loadEmployeeSalary() here
        updatePayrollUrl(selectedYear, selectedGroupBy, page);
      }
    : (page: number, ps?: number) => {
        setCurrentPage(page);
        updatePayrollUrl(selectedYear, selectedGroupBy, page);
      };

  useEffect(() => {
    if (!isMonthly) {
      loadEmployeeSalary();
    }
  }, [pageSize]);
  const handleSendMail = async (month: number, year: number) => {
    setIsSending(true);
    try {
      await api("/send-mail", {
        method: "POST",
        body: { month, year },
      });
      toast.success("Mail sent successfully");
      closeMailConfirm();
    } catch (err) {
      console.error(err);
      toast.error("Failed to send mail");
    } finally {
      setIsSending(false);
    }
  };

  const handleSendMailToEmployee = async (month: number, year: number) => {
    try {
      setIsSending(true);
      await api("/send-mail", {
        method: "POST",
        body: { EmployeeId: user.id, month, year },
      });
      toast.success("Mail sent successfully");
      closeMailConfirm();
    } catch (err) {
      console.error(err);
      toast.error("Failed to send mail");
    } finally {
      setIsSending(false);
    }
  };

  const handleImageClick = (
    employeeId: string | number,
    employeeName: string
  ) => {
    navigate(`/profile/${employeeId}`, {
      state: {
        employeeName,

        from: "payroll",

        previousUrl: location.pathname + location.search,
        payrollUrl: location.pathname + location.search,
      },
    });
  };

  const handleRowClickGeneric = (rec: any) => {
    // only allow row-click for role_name === 1
    if (user.role_name !== 1) {
      return;
    }

    if (isMonthly) {
      handleMonthlySalary(rec.fiscalMonth, rec.year);
    } else {
      handleEmployeeSalary(rec.employee_id, rec.name);
    }
  };

  // Stats cards
  const stats = [
    { title: "Gross", value: totalGross },
    { title: "SD", value: totalSD },
    { title: "TDS", value: totalTDS },
    { title: "PF", value: totalPf },
    { title: "ESIC", value: totalEsic },
    { title: "Net", value: totalNet },
  ];

  useEffect(() => {
    const PayrollMobileFilters = () => (
      <div className="upper-absolute-class">
        <div className="payroll-filters d-flex align-items-center flex-wrap">
          <div className="d-flex holiday-full-width align-items-center gap-2 ">
            {(selectedYear !== defaultYear ||
              selectedGroupBy !== defaultGroupBy) && (
              <button
                className="btn add_btn_size btn-outline-primary"
                onClick={resetFilters}
                title="Reset Filters"
              >
                <i className="ti ti-refresh" />
              </button>
            )}
            {user.role_name === 1 && (
              <i
                className="fas fa-file-excel"
                title="Download Excel"
                onClick={() => {
                  handleDownloadExcel(selectedYear, selectedGroupBy);
                }}
                style={{
                  cursor: "pointer",
                  fontSize: "20px",
                  marginLeft: "5px",
                  color: "#212529",
                }}
              />
            )}

            <div className="holiday-flex">
              <CommonSelect
                options={yearOptions}
                value={yearOptions.find((opt) => opt.value === selectedYear)}
                onChange={(opt) => {
                  const y = opt?.value || getCurrentFinancialYear();
                  setSelectedYear(y);
                  setCurrentPage(1); // ADD THIS
                  updatePayrollUrl(y, selectedGroupBy);
                }}
                forceFullWidth={isMobile}
              />
            </div>
            {user.role_name === 1 && (
              <div
                className="holiday-flex"
                style={{ marginRight: isMobile ? "10px" : "0" }}
              >
                <CommonSelect
                  options={groupByOptions}
                  value={groupByOptions.find(
                    (opt) => opt.value === selectedGroupBy
                  )}
                  onChange={(opt) => {
                    const g = opt?.value as "monthly" | "employee";
                    setSelectedGroupBy(g);
                    setCurrentPage(1); // ADD THIS
                    updatePayrollUrl(selectedYear, g);
                  }}
                  forceFullWidth={isMobile}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );

    const PayrollDesktopFilters = () => (
      <div className="">
        <div className="payroll-filters d-flex align-items-center justify-content-end flex-wrap">
          <div className="d-flex align-items-center gap-2 ">
            {(selectedYear !== defaultYear ||
              selectedGroupBy !== defaultGroupBy) && (
              <button
                className="btn add_btn_size btn-outline-primary"
                onClick={resetFilters}
                title="Reset Filters"
              >
                <i className="ti ti-refresh" />
              </button>
            )}
            {user.role_name === 1 && (
              <i
                className="fas fa-file-excel"
                title="Download Excel"
                onClick={() => {
                  handleDownloadExcel(selectedYear, selectedGroupBy);
                }}
                style={{
                  cursor: "pointer",
                  fontSize: "20px",
                  marginLeft: "5px",
                  color: "#212529",
                }}
              />
            )}

            <CommonSelect
              options={yearOptions}
              value={yearOptions.find((opt) => opt.value === selectedYear)}
              onChange={(opt) => {
                const y = opt?.value || getCurrentFinancialYear();
                setSelectedYear(y);
                setCurrentPage(1); // ADD THIS
                updatePayrollUrl(y, selectedGroupBy,1);
              }}
            />
            {user.role_name === 1 && (
              <CommonSelect
                options={groupByOptions}
                value={groupByOptions.find(
                  (opt) => opt.value === selectedGroupBy
                )}
                onChange={(opt) => {
                  const g = opt?.value as "monthly" | "employee";
                  setSelectedGroupBy(g);
                  setCurrentPage(1); // ADD THIS
                  updatePayrollUrl(selectedYear, g,1);
                }}
              />
            )}
          </div>
        </div>
      </div>
    );

    setFilters(
      isMobileView ? <PayrollMobileFilters /> : <PayrollDesktopFilters />
    );
    return () => {
      setFilters(null);
    };
  }, [selectedYear, selectedGroupBy, isMobile, isMobileView]);

  return (
    <>
      <HeaderFilterProvider>
        <div className="page-wrapper d-flex flex-column">
          <div className="content flex-grow-1">
            <StatCardGrid
              items={stats}
              formatValue={formatCurrency}
              currencySymbol
            />

            <div className="card card-margin-bottom table-container">
              <div
                className="card-body p-0 table-wrapper "
                id="Designation-list"
                style={{
                  height: tableHeight,
                  display: "flex",
                  flexDirection: "column",
                  overflowY: isMobileView ? "auto" : "auto",
				  overflowX: "hidden", 
                }}
              >
                <Table
                  style={{ flex: 1 }}
                  dataSource={dataSource}
                  columns={columns}
                  rowKey={rowKey}
                  totalItems={totalItemsCount}
                  pageSize={pageSize}
                  rowClassName={() => "clickable-row"}
                  loading={loading}
                  currentPage={selectedGroupBy === "employee" ? currentPage : 1}
                  onPageChange={handlePageChange}
                  onRowClick={handleRowClickGeneric}
                />
              </div>
            </div>
            {showMailModal && (
              <>
                {/* Backdrop */}
                <div
                  className="modal-backdrop fade show"
                  style={{
                    backgroundColor: "rgba(0, 0, 0, 2.6)",
                    zIndex: 1040,
                  }}
                />
                <div
                  className="modal fade show d-block"
                  style={{ zIndex: 1050 }}
                  role="dialog"
                  aria-modal="true"
                >
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Send Mail</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={closeMailConfirm}
                        />
                      </div>

                      <div className="modal-body">
                        <p>Are you sure you want to send mail?</p>
                      </div>

                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn"
                          onClick={closeMailConfirm}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => {
                            if (modalMonth != null && modalYear != null) {
                              handleSendMail(modalMonth, modalYear);
                            } else if (
                              modalMonth2 != null &&
                              modalYear2 != null
                            ) {
                              handleSendMailToEmployee(modalMonth2, modalYear2);
                            }
                          }}
                          disabled={isSending}
                        >
                          {isSending ? "Sending..." : "Send"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          <div></div>
          <div>
            <Footer />
          </div>
        </div>
      </HeaderFilterProvider>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default Payroll;
